<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="community-migrant-handbook-wrapper bg-white">
    <Head>
      <Title>{{ $messages('migrant-handbook.title') }}</Title>
      <Meta hid="description" name="description" :content="$messages('migrant-handbook.description')" />
    </Head>
    <CommunityMigrantHandbookHero
      img="https://majority.imgix.net/web-assets/migrant-handbook/migrant-handbook-banner.jpg"
      :title="titleText"
      :breadcrumbs="breadcrumbs"
    >
      <template #default="{ variant }">
        <div
          class="max-w-lg font-light leading-4 text-center text-smallest md:text-display-7 -tracking-01-em md:-tracking-04-em md:leading-8 lg:text-left"
          v-html="disclaimerText"
        />
        <form class="lg:max-w-86" @submit.prevent="onSubmit">
          <template v-if="success !== true">
            <input
              ref="emailInput"
              v-model="inputValue"
              type="email"
              class="w-full py-3 mt-5 mb-1 bg-transparent border-t-0 border-r-0 border-l-0 border-b-2 rounded-none outline-none border-bright-yellow placeholder-bright-yellow/25"
              placeholder="example@email.com"
            >
            <p
              class="mt-px font-light leading-5 font-gt-america text-smallest"
              v-html="
                $messages('migrant-handbook.hero.disclaimer', {
                  variant: 'underline',
                  privacy_policy_link: $mRouter.getLocalRoute({
                    name: 'terms-of-use-slug',
                    params: {slug: $i18n.locale === 'es' ? 'politica-de-privacidad' : 'privacy-policy'}
                  }).href,
                })
              "
            />
            <div
              class="flex flex-col items-center justify-center mt-6 lg:flex-row lg:flex-wrap lg:justify-start"
            >
              <button
                type="submit"
                class="mx-auto btn lg:mx-0 btn-bright-yellow"
              >
                {{ $messages("migrant-handbook.hero.cta") }}
              </button>
            </div>
          </template>
        </form>
      </template>
    </CommunityMigrantHandbookHero>
    <CommunityMigrantHandbookList />

    <LazyBlocksUserReviewList />
    <LazyBlocksFaqV2 v-bind="$messages('faq')" />

    <LazyBlocksMiniCheckout id="checkout" ref="checkout" />
  </div>
</template>

<script>
import validateEmail from '@/utils/validate-email'

export default {
  name: 'CommunityMigrantHandbook',
  setup () {
    definePageMeta({
      key: to => to.fullPath
    })
    const fetchClient = useFetchClient('','User API Majority - migrant-handbook')
    return {
      fetchClient
    }
  },
  data () {
    return {
      breadcrumbs: [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.migrant_handbook')
        }
      ],
      loading: false,
      hero: {
        title: this.$messages('migrant-handbook.hero.title')
      },
      inputValue: '',
      success: null
    }
  },
  computed: {
    titleText () {
      if (this.success) {
        return this.$messages('migrant-handbook.hero.success.title')
      } else {
        return this.hero.title
      }
    },
    disclaimerText () {
      if (this.success) {
        return this.$messages('migrant-handbook.hero.success.body', { email: this.inputValue })
      } else {
        return this.$messages('migrant-handbook.hero.body')
      }
    }
  },
  methods: {
    async onSubmit () {
      if (validateEmail(this.inputValue)) {
        try {
          this.loading = true

          await this.fetchClient.post(
            'https://rest.iad-05.braze.com/users/alias/new',
            {
              user_aliases: [
                {
                  alias_name: 'email',
                  alias_label: this.inputValue
                }
              ]
            },
            { 'Content-Type': 'application/json', Authorization: 'Bearer 58ffb062-d04c-49d0-aa4d-65a06de6236a' })

          await this.fetchClient.post(
            'https://rest.iad-05.braze.com/users/track',
            {
              attributes: [
                {
                  user_alias: {
                    alias_name: 'email',
                    alias_label: this.inputValue
                  },
                  email: this.inputValue
                }
              ],
              events: [
                {
                  user_alias: {
                    alias_name: 'email',
                    alias_label: this.inputValue
                  },
                  name: `Requested Migrant Handbook ${this.$i18n.locale.toUpperCase()}`,
                  time: new Date()
                }
              ]
            },
            { 'Content-Type': 'application/json', Authorization: 'Bearer 58ffb062-d04c-49d0-aa4d-65a06de6236a' }
          )

          this.success = true
        } catch (error) {
          this.loading = false
          this.success = false
        }
      } else {
        await this.$refs.emailInput.focus()
        this.loading = true
        this.success = false
      }
    }
  }

}
</script>
<style>
</style>

<style lang="postcss">
  .community-migrant-handbook-wrapper {
    .feature-hero-wrapper {
      @screen lg {
        min-height: 640px !important;
        height: 720px !important;
      }
    }
  }
</style>
